// Page: savings-intro-il  (Illinois LMI "savings intro" / income-qualification step)
//
// Ported from the inline <script> in
//   Enrollment_modules/info-il-lmi/savings-intro.module/module.html (lines 425–2619).
//
// Near-duplicate of savings-intro.ts (the non-IL info-lmi module) but materially
// different: it drives a dynamic IL LMI-config flow (getAvailability → lmiFlow),
// uses `income`-cased identifiers, 1-arg popup helpers, and IL redirect targets —
// hence a separate file/page-key rather than a branch of savings-intro.
//
// MECHANICAL / FAITHFUL PORT — runtime behaviour is preserved. Deliberate changes
// (same family as the pilot, see docs/handoff/global-js-deep-refactor-notes.md):
//   1. Selectors scoped to the HubSpot render-time wrapper `#page_1_lmi_widget
//      #child` are scoped to `root`; bare `document.getElementById` /
//      `document.querySelector('#id' | '.class')` (incl. cross-widget
//      `#page_1_my_info_widget …`) stay document-scoped, as in the original.
//   2. `_hcms/api/*` fetches → apiUrl; same-origin redirects → root-relative
//      ("/il-usage" …). External hosts (aws.nautilussolar.com, hansen.danmarcrm.com)
//      and *.fs1.hubspotusercontent-na1.net assets are left as-is.
//   3. HubDB read URLs are built with core/hubdb `hubdbRowsUrl` (table id + portal
//      from window.__ENV__) instead of the inline `api.hubapi.com` template literals.
//   4. localStorage → core/storage (rawGet/rawSet).
//   5. Inline onclick/ondrop/ondragover handlers are bound in init (rule G),
//      preserving the exact call arguments (which differ from the non-IL module).
//
// Large blocks of commented-out dead code in the original inline script are omitted
// (comments have no runtime effect). Dynamic ES5 patterns are typed `any`; `var` is
// kept where the original used it so hoisting semantics match. `Swiper`/`pdfjsLib`
// are CDN globals and `delay` is provided at runtime by sibling module inline
// scripts; none are declared in the theme-root global.d.ts, so they are declared
// module-locally (see final report).

import { apiUrl } from "../../core/api"
import { hubdbRowsUrl } from "../../core/hubdb"
import * as storage from "../../core/storage"

// Swiper + pdfjsLib are CDN globals declared theme-wide in global.d.ts.
declare const checkValue: any
declare function delay(ms: number): Promise<any>

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/savings/savings-intro-il.ts","init",[root,_config],["root","_config"]);
  // implicit globals in the original (bare assigns, no `var`) — declared here so
  // strict-mode ESM doesn't throw ReferenceError.
  let checkedValue: any
  let responseFromAPI: any = ""
  let exampleUtilityId: any

  /* loader function */
  function LMIopenLoader() {
__ea_trace("modules/savings/savings-intro-il.ts","LMIopenLoader",[],[]);
    var loader = document.getElementById("lmILoader") as HTMLElement
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    ;(document.getElementById("LMIloaderOverlay") as HTMLElement).style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as any).disabled = true
    })
  }
  function LMIcloseLoader() {
__ea_trace("modules/savings/savings-intro-il.ts","LMIcloseLoader",[],[]);
    var loader = document.getElementById("lmILoader") as HTMLElement
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    ;(document.getElementById("LMIloaderOverlay") as HTMLElement).style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as any).disabled = false
    })
  }
  /* loader function */

  //index DB
  var request = indexedDB.open("LmiDatabase", 1)
  var db: any
  request.onerror = (event) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    console.log(`Database error: ${(event.target as any).errorCode}`)
  }
  request.onsuccess = (event) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    db = (event.target as any).result
    getAllFilesFromIndexedDB()
  }
  request.onupgradeneeded = (event) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    var db = (event.target as any).result
    var objectStore = db.createObjectStore("files", { autoIncrement: true })
    objectStore.createIndex("name", "name", { unique: false })
  }

  // Function to save file to IndexedDB
  function saveFileToIndexedDB(file: any, checkValue?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","saveFileToIndexedDB",[file,checkValue],["file","checkValue"]);
    try {
      var reader = new FileReader()
      reader.onload = (event) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
        var arrayBuffer = (event.target as any).result
        var fileObject = {
          name: file.name,
          type: file.type,
          data: arrayBuffer,
          checkValue: checkValue,
        }
        var transaction = db.transaction(["files"], "readwrite")
        var objectStore = transaction.objectStore("files")
        var request = objectStore.put(fileObject)

        request.onerror = (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
          console.log(`Database error: ${(event.target as any).errorCode}`)
        }
      }
      reader.onerror = (event) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
        console.error("Error reading file:", (event.target as any).error)
      }
      reader.readAsArrayBuffer(file)
    } catch (e) {
    }
  }
  function getAllFilesFromIndexedDB() {
__ea_trace("modules/savings/savings-intro-il.ts","getAllFilesFromIndexedDB",[],[]);
    var transaction = db.transaction(["files"], "readonly")
    var objectStore = transaction.objectStore("files")
    var filess: any[] = []
    var censusFile: any[] = []
    var incomeFile: any[] = []
    var index = 0

    objectStore.openCursor().onsuccess = (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
      var cursor = (event.target as any).result
      if (cursor) {
        var fileName = cursor.value.name
        var blobData = cursor.value.data
        var fileType = cursor.value.type
        var file = new File([blobData], fileName, { type: fileType })
        index++
        if (checkValue === "cencus") {
          censusFile.push(file)
        } else if (checkValue === "blue") {
          incomeFile.push(file)
        } else {
          filess.push(file)
        }
        cursor.continue()
      } else {
        if (index !== 0) {
          if (filess.length > 0) {
            handleFilesNew(filess, false, false)
          }
          if (censusFile.length > 0) {
            handleFilesNew(censusFile, true, false)
          }
          if (incomeFile.length > 0) {
            handleFilesNew(incomeFile, false, true)
          }
        }
      }
    }
  }
  // Function to clear the entire IndexedDB database
  function clearDatabase() {
__ea_trace("modules/savings/savings-intro-il.ts","clearDatabase",[],[]);
    var transaction = db.transaction(db.objectStoreNames, "readwrite")
    transaction.oncomplete = () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
    }
    transaction.onerror = (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    }
    Array.from(db.objectStoreNames as any).forEach((storeName: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[storeName],["storeName"]);
      var objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }
  //End of Indexed Db///

  var storedDisplayElementList = JSON.parse(storage.rawGet("displayLMIElementList") as any)
  var storedRequireElementList = JSON.parse(storage.rawGet("requireLMIElementList") as any)
  var SessionLocalStorage = JSON.parse(storage.rawGet("UtilitySessionDetails") as any)
  void SessionLocalStorage
  var shouldValidate = false
  void shouldValidate
  function ShowHide() {
__ea_trace("modules/savings/savings-intro-il.ts","ShowHide",[],[]);
    var incomdeExceedElement = root.querySelector("#Income_Exceed_Threshold") as HTMLElement
    var programParticipation = root.querySelector("#Program_Participation") as HTMLElement
    var requestIncomCheck = root.querySelector("#Request_Income_Check") as HTMLElement
    if (storedDisplayElementList != null) {
      if (storedDisplayElementList.includes("INCOME EXCEED DISPLAY")) {
        incomdeExceedElement.style.display = "block"
      } else {
        incomdeExceedElement.style.display = "none"
      }

      if (storedDisplayElementList.includes("PROGRAM PARTICIPATION DISPLAY")) {
        programParticipation.style.display = "block"
      } else {
        programParticipation.style.display = "none"
      }
      if (storedDisplayElementList.includes("REQUEST INCOME DISPLAY")) {
        requestIncomCheck.style.display = "block"
      } else {
        requestIncomCheck.style.display = "none"
      }
    }
  }
  ShowHide()

  //Validation
  function RequireNotRequire() {
__ea_trace("modules/savings/savings-intro-il.ts","RequireNotRequire",[],[]);
    var isValidationSuccess = false
    var incomdeExceedElement = root.querySelector("#Income_Exceed_Threshold") as HTMLElement
    var programParticipation = root.querySelector("#Program_Participation") as HTMLElement
    var requestIncomCheck = root.querySelector("#Request_Income_Check") as HTMLElement
    void incomdeExceedElement
    void programParticipation
    void requestIncomCheck

    var RadioName = document.getElementsByName("color")
    var isAnyChecked = false

    for (var i = 0; i < RadioName.length; i++) {
      if ((RadioName[i] as HTMLInputElement).checked) {
        isAnyChecked = true
        checkedValue = (RadioName[i] as HTMLInputElement).value
        break
      }
    }

    if (!isAnyChecked) {
      ;(root.querySelector("#NoRadioSelected_error_message") as HTMLElement).innerHTML = "Please select an option."
      return false
    } else {
      ;(root.querySelector("#NoRadioSelected_error_message") as HTMLElement).innerHTML = ""

      switch (checkedValue) {
        case "red":
          {
            isValidationSuccess = true
          }
          break
        case "green":
          {
            var tempErrorList: any[] = [validateSelectedOption(), fileFinalButtonValidation(false, false)]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "blue":
          {
            if (listOfincomeFiles.length === 0) {
              ;(document.getElementById("income_track_map_upload_error_message") as HTMLElement).textContent =
                "Please upload file to proceed"
              return
            }
            var tempErrorList: any[] = [fileFinalButtonValidation(true, true)]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "orange":
          {
            var tempErrorList: any[] = [validateCheckSignature()]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "cencus":
          {
            if (listOfCensusFiles.length === 0) {
              ;(document.getElementById("Cencus_track_map_upload_error_message") as HTMLElement).textContent =
                "Please upload file to proceed"
              return
            }
            var tempErrorList: any[] = [fileFinalButtonValidation(true, false)]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
      }
    }

    return isValidationSuccess
  }
  /* -- validation --------------------------------- */
  function initSwiper() {
__ea_trace("modules/savings/savings-intro-il.ts","initSwiper",[],[]);
    swiper = new Swiper(".swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Program_Participation .swiper-button-next",
        prevEl: "#Program_Participation .swiper-button-prev",
      },
    })
    ;(document.querySelector("#Program_Participation .swiper-button-next") as HTMLElement).innerHTML =
      "<span>Next</span>"
    ;(document.querySelector("#Program_Participation .swiper-button-prev") as HTMLElement).innerHTML =
      "<span>Previous</span>"
  }
  function initCensusSwiper() {
__ea_trace("modules/savings/savings-intro-il.ts","initCensusSwiper",[],[]);
    censusSwiper = new Swiper(".census-swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Cencus_tract_map_upload .swiper-button-next",
        prevEl: "#Cencus_tract_map_upload .swiper-button-prev",
      },
    })

    ;(document.querySelector("#Cencus_tract_map_upload .swiper-button-next") as HTMLElement).innerHTML =
      "<span>Next</span>"
    ;(document.querySelector("#Cencus_tract_map_upload .swiper-button-prev") as HTMLElement).innerHTML =
      "<span>Previous</span>"
  }
  function initincomeSwiper() {
__ea_trace("modules/savings/savings-intro-il.ts","initincomeSwiper",[],[]);
    incomeSwiper = new Swiper(".income-swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Request_Income_Check .swiper-button-next",
        prevEl: "#Request_Income_Check .swiper-button-prev",
      },
    })

    ;(document.querySelector("#Request_Income_Check .swiper-button-next") as HTMLElement).innerHTML =
      "<span>Next</span>"
    ;(document.querySelector("#Request_Income_Check .swiper-button-prev") as HTMLElement).innerHTML =
      "<span>Previous</span>"
  }
  function fileFinalButtonValidation(isUploadCensus?: any, isUploadincome?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","fileFinalButtonValidation",[isUploadCensus,isUploadincome],["isUploadCensus","isUploadincome"]);
    if (isUploadCensus) {
      var errorMessageElement = document.getElementById("census-file-error-message") as HTMLElement
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)
      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
        // ok
      } else {
        return "error"
      }
    } else if (isUploadincome) {
      var errorMessageElement = document.getElementById("income-file-error-message") as HTMLElement
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)
      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
        // ok
      } else {
        return "error"
      }
    } else {
      var errorMessageElement = document.getElementById("file-error-message") as HTMLElement
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)
      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
        // ok
      } else {
        return "error"
      }
    }
  }
  function captureFromCamera() {
__ea_trace("modules/savings/savings-intro-il.ts","captureFromCamera",[],[]);
    var inputElement = document.createElement("input")
    inputElement.type = "file"
    inputElement.accept = "image/*"
    ;(inputElement as any).capture = "camera"
    inputElement.addEventListener("change", function (this: HTMLInputElement) {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[this],["this"]);
      handleFilesNew(this.files)
    })

    inputElement.click()
  }
  void captureFromCamera
  function removeImageOpenPopup(isCensus?: any, isincome?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","removeImageOpenPopup",[isCensus,isincome],["isCensus","isincome"]);
    if (isCensus) {
      ;(document.querySelector(".census-RemoveFilePopup") as HTMLElement).style.display = "block"
    } else if (isincome) {
      ;(document.querySelector(".income-RemoveFilePopup") as HTMLElement).style.display = "block"
    } else {
      ;(document.querySelector(".RemoveFilePopup") as HTMLElement).style.display = "block"
    }
  }
  function removeCurrentImage(isUploadCensus?: any, isUploadincome?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","removeCurrentImage",[isUploadCensus,isUploadincome],["isUploadCensus","isUploadincome"]);
    if (isUploadCensus) {
      if (censusSwiper !== undefined) {
        var activeIndex = censusSwiper.activeIndex
        ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML = ""

        listOfCensusFiles.splice(activeIndex, 1)
        censusSwiper.removeSlide(activeIndex)
        ;(document.getElementById("censusfileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfCensusFiles.length}`

        initCensusSwiper()
        var fileNameDisplay = document.getElementById("censusfileNameDisplay") as HTMLElement
        fileNameDisplay.textContent = `File Name: ${listOfCensusFiles.map((f: any) => f.name).join(", ")}`

        ;(document.querySelector(".census-RemoveFilePopup") as HTMLElement).style.display = "none"
      } else {
      }
    } else if (isUploadincome) {
      if (incomeSwiper !== undefined) {
        var activeIndex = incomeSwiper.activeIndex
        ;(document.getElementById("income-file-error-message") as HTMLElement).innerHTML = ""

        listOfincomeFiles.splice(activeIndex, 1)
        incomeSwiper.removeSlide(activeIndex)
        ;(document.getElementById("incomefileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfincomeFiles.length}`

        initincomeSwiper()
        var fileNameDisplay = document.getElementById("incomefileNameDisplay") as HTMLElement
        fileNameDisplay.textContent = `File Name: ${listOfincomeFiles.map((f: any) => f.name).join(", ")}`

        ;(document.querySelector(".income-RemoveFilePopup") as HTMLElement).style.display = "none"
      } else {
      }
    } else {
      if (swiper !== undefined) {
        var activeIndex = swiper.activeIndex
        ;(document.getElementById("file-error-message") as HTMLElement).innerHTML = ""

        listOfFiles.splice(activeIndex, 1)
        swiper.removeSlide(activeIndex)
        ;(document.getElementById("fileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfFiles.length}`

        initSwiper()

        var fileNameDisplay = document.getElementById("fileNameDisplay") as HTMLElement
        fileNameDisplay.textContent = `File Name: ${listOfFiles.map((f: any) => f.name).join(", ")}`

        ;(document.querySelector(".RemoveFilePopup") as HTMLElement).style.display = "none"
      } else {
      }
    }
  }

  function removeImageClosePopup(isCensus?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","removeImageClosePopup",[isCensus],["isCensus"]);
    if (isCensus) {
      ;(document.querySelector(".census-RemoveFilePopup") as HTMLElement).style.display = "none"
    } else {
      ;(document.querySelector(".RemoveFilePopup") as HTMLElement).style.display = "none"
    }
  }
  function triggerFilePicker() {
__ea_trace("modules/savings/savings-intro-il.ts","triggerFilePicker",[],[]);
    ;(document.getElementById("file-error-message") as HTMLElement).innerHTML = ""
    ;(document.querySelector("#fileInput") as HTMLElement).click()
  }
  function triggerCensusFilePicker() {
__ea_trace("modules/savings/savings-intro-il.ts","triggerCensusFilePicker",[],[]);
    ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML = ""
    ;(document.querySelector("#censusFileInput") as HTMLElement).click()
  }
  function triggerincomeFilePicker() {
__ea_trace("modules/savings/savings-intro-il.ts","triggerincomeFilePicker",[],[]);
    ;(document.getElementById("income-file-error-message") as HTMLElement).innerHTML = ""
    ;(document.querySelector("#incomeFileInput") as HTMLElement).click()
  }
  ;(document.getElementById("fileInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, false)
  })
  ;(document.getElementById("censusFileInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, true, false)
  })
  ;(document.getElementById("incomeFileInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, true)
  })
  function triggerFileInput(event: any, isUploadCensus?: any, isUploadincome?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","triggerFileInput",[event,isUploadCensus,isUploadincome],["event","isUploadCensus","isUploadincome"]);
    event.preventDefault()
    if (isUploadCensus) {
      ;(document.querySelector('#censusMobileCamera input[type="file"]') as HTMLElement).click()
    } else if (isUploadincome) {
      ;(document.querySelector('#incomeMobileCamera input[type="file"]') as HTMLElement).click()
    } else {
      ;(document.querySelector('#mobileCamera input[type="file"]') as HTMLElement).click()
    }
  }
  ;(document.getElementById("imageInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, false)
  })
  ;(document.getElementById("censusImageInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, true, false)
  })
  ;(document.getElementById("incomeImageInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, true)
  })
  function dragOverHandler(event: any, isUploadCensus?: any, isUploadincome?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","dragOverHandler",[event,isUploadCensus,isUploadincome],["event","isUploadCensus","isUploadincome"]);
    event.preventDefault()
    if (isUploadCensus) {
      ;(root.querySelector("#censusDropArea") as HTMLElement).classList.add("active")
    } else if (isUploadincome) {
      ;(root.querySelector("#incomeDropArea") as HTMLElement).classList.add("active")
    } else {
      ;(root.querySelector("#dropArea") as HTMLElement).classList.add("active")
    }
  }
  function dropHandler(event: any, isUploadCensus?: any, isUploadincome?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","dropHandler",[event,isUploadCensus,isUploadincome],["event","isUploadCensus","isUploadincome"]);
    event.preventDefault()
    if (isUploadCensus) {
      ;(root.querySelector("#censusDropArea") as HTMLElement).classList.remove("active")
    } else if (isUploadincome) {
      ;(root.querySelector("#incomeDropArea") as HTMLElement).classList.remove("active")
    } else {
      ;(root.querySelector("#dropArea") as HTMLElement).classList.remove("active")
    }

    var files = event.dataTransfer.files
    if (isUploadCensus) {
      ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML = ""
    } else if (isUploadincome) {
      ;(document.getElementById("income-file-error-message") as HTMLElement).innerHTML = ""
    } else {
      ;(document.getElementById("file-error-message") as HTMLElement).innerHTML = ""
    }
    if (files.length > 0) {
      handleFilesNew(files, isUploadCensus, isUploadincome)
    }
  }
  function browseFiles(isUploadCensus?: any, isUploadincome?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","browseFiles",[isUploadCensus,isUploadincome],["isUploadCensus","isUploadincome"]);
    var inputElement = document.createElement("input")
    inputElement.type = "file"
    inputElement.accept = "application/pdf, image/*"
    inputElement.addEventListener("change", function (this: HTMLInputElement) {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[this],["this"]);
      handleFilesNew(this.files, isUploadCensus, isUploadincome)
    })

    inputElement.click()
  }
  void browseFiles
  var _file: any
  void _file
  var isInvalidFileType = false
  void isInvalidFileType
  var isExceededSize = false
  void isExceededSize
  var listOfFiles: any[] = []
  var listOfCensusFiles: any[] = []
  var listOfincomeFiles: any[] = []
  var swiper: any
  var censusSwiper: any
  var incomeSwiper: any
  function handleFilesNew(files: any, isUploadCensus?: any, isUploadincome?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","handleFilesNew",[files,isUploadCensus,isUploadincome],["files","isUploadCensus","isUploadincome"]);
    var maxFiles = 12
    var totalfilecount = 0
    if (isUploadCensus) {
      totalfilecount = listOfCensusFiles.length + files.length
    } else if (isUploadincome) {
      totalfilecount = listOfincomeFiles.length + files.length
    } else {
      totalfilecount = listOfFiles.length + files.length
    }

    if (files.length > 0 && totalfilecount <= maxFiles) {
      var allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/heic", "image/bmp", "image/webp"]

      for (var i = 0; i < files.length; i++) {
        var file = files[i]

        if (!allowedTypes.includes(file.type)) {
          if (isUploadCensus) {
            ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          } else if (isUploadincome) {
            ;(document.getElementById("income-file-error-message") as HTMLElement).innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          } else {
            ;(document.getElementById("file-error-message") as HTMLElement).innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          }
          return
        }
      }

      if (file.size > 10 * 1024 * 1024) {
        if (isUploadCensus) {
          ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        } else if (isUploadincome) {
          ;(document.getElementById("income-file-error-message") as HTMLElement).innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        } else {
          ;(document.getElementById("file-error-message") as HTMLElement).innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        }
        return
      }
      var fileNameDisplay: any
      var previewContainer: any
      if (isUploadCensus) {
        fileNameDisplay = document.getElementById("censusfileNameDisplay")
        previewContainer = document.getElementById("censusPreviewContainer")
      } else if (isUploadincome) {
        fileNameDisplay = document.getElementById("incomefileNameDisplay")
        previewContainer = document.getElementById("incomePreviewContainer")
      } else {
        fileNameDisplay = document.getElementById("fileNameDisplay")
        previewContainer = document.getElementById("previewContainer")
      }

      for (var j = 0; j < files.length; j++) {
        var file = files[j]
        var reader = new FileReader()
        var preview = document.createElement("div")
        preview.className = "swiper-slide"
        preview.innerHTML = `<img src="" alt="Preview Image" width="100%" height="auto" id="imageNo${j}">`
        previewContainer.appendChild(preview)

        reader.onload = ((preview, file) => (e: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[e],["e"]);
          if (file.type === "application/pdf") {
            pdfjsLib.getDocument(e.target.result).promise.then((pdf: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[pdf],["pdf"]);
              pdf.getPage(1).then((page: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[page],["page"]);
                var canvas = document.createElement("canvas")
                var context = canvas.getContext("2d")
                var viewport = page.getViewport({ scale: 1.5 })
                canvas.height = viewport.height
                canvas.width = viewport.width
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                }
                page.render(renderContext).promise.then(() => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
                  ;(preview.querySelector("img") as HTMLImageElement).src = canvas.toDataURL("image/jpeg")
                })
              })
            })
          } else {
            ;(preview.querySelector("img") as HTMLImageElement).src = e.target.result
          }

          var blobUrl = URL.createObjectURL(file)
          void blobUrl
          if (isUploadCensus) {
            initCensusSwiper()
          } else if (isUploadincome) {
            initincomeSwiper()
          } else {
            initSwiper()
          }
        })(preview, file)

        reader.readAsDataURL(file)
        if (isUploadCensus) {
          listOfCensusFiles.push(file)
        } else if (isUploadincome) {
          listOfincomeFiles.push(file)
        } else {
          listOfFiles.push(file)
        }
      }

      fileNameDisplay.textContent = `File Name: ${listOfFiles.map((f: any) => f.name).join(", ")}`
      if (isUploadCensus) {
        ;(document.getElementById("censusfileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfCensusFiles.length}`
      } else if (isUploadincome) {
        ;(document.getElementById("incomefileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfincomeFiles.length}`
      } else {
        ;(document.getElementById("fileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfFiles.length}`
      }
    } else {
      if (isUploadCensus) {
        ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      } else if (isUploadincome) {
        ;(document.getElementById("income-file-error-message") as HTMLElement).innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      } else {
        ;(document.getElementById("file-error-message") as HTMLElement).innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      }
    }
  }
  // -- uploaded file to file manager and return file url ---------------------
  var uploadedurl: any[] = []
  void uploadedurl
  async function uploadFileToServer() {
__ea_trace("modules/savings/savings-intro-il.ts","uploadFileToServer",[],[]);
    clearDatabase()

    const uploadedUrls: any[] = []
    var theList: any
    if (checkedValue === "cencus") {
      theList = listOfCensusFiles
    } else if (checkedValue === "blue") {
      theList = listOfincomeFiles
    } else {
      theList = listOfFiles
    }

    for (const file of theList) {
      try {
        const formData = new FormData()
        const originalName = file.name

        const safeName = originalName
          .replace(/[\u0000-\u001F\u007F-\u009F]/g, "")
          .replace(/[^\x00-\x7F]/g, "")
          .replace(/\s+/g, " ")

        formData.append("file", file, safeName)
        formData.append("name", safeName)

        const requestOptions = {
          method: "POST",
          body: formData,
        }

        // External file-manager endpoint (aws.nautilussolar.com) — not a HubSpot
        // serverless function, so left as an absolute URL.
        const response = await fetch("https://aws.nautilussolar.com/testRoute/uploadFileToFileManager", requestOptions)
        responseFromAPI = await response.json()
        if (response.ok) {
          saveFileToIndexedDB(file, checkedValue)
          uploadedUrls.push(responseFromAPI.response.url)
        } else {
          throw new Error("Error uploading file")
        }
      } catch (error) {
        throw error
      }
    }
    return uploadedUrls
  }

  // -- uploaded file to file manager -----------------------------------------
  function removeAllImages() {
__ea_trace("modules/savings/savings-intro-il.ts","removeAllImages",[],[]);
    ;(document.getElementById("file-error-message") as HTMLElement).innerHTML = ""

    listOfFiles = []

    while (swiper.slides.length > 0) {
      swiper.removeSlide(0)
    }

    ;(document.getElementById("fileCount") as HTMLElement).textContent = `Total files selected: ${listOfFiles.length}`

    initSwiper()

    var fileNameDisplay = document.getElementById("fileNameDisplay") as HTMLElement
    fileNameDisplay.textContent = "File Name: "
  }
  void removeAllImages
  // append selected option's value below selectbox ----------
  var optns = root.querySelector("#incomeThreshold-options") as HTMLSelectElement
  var replacementDiv = root.querySelector("#appendDocument") as HTMLElement
  var selectedProgramSelection = ""
  optns.addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
    var selectedValue = optns.value
    var selectedOption = optns.options[optns.selectedIndex]
    selectedProgramSelection = selectedOption.textContent as string
    var selectedOptionValue = selectedValue
    if (selectedOptionValue !== "") {
      const filesArray = selectedOptionValue.split(",").map((file) => file.trim())
      const selectBox = document.querySelector(
        "#page_1_lmi_widget #appendDocument #programFilesOptions",
      ) as HTMLSelectElement
      selectBox.innerHTML = '<option selected="" disabled="">Select an option</option>'

      /* ------------- lmi database removed  --------- */
      removeCurrentImage(false)

      filesArray.forEach((file) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[file],["file"]);
        const option = document.createElement("option")
        option.value = file
        option.textContent = file
        selectBox.appendChild(option)
      })
      replacementDiv.innerHTML = ""
      replacementDiv.appendChild(selectBox)
    } else {
      replacementDiv.innerHTML = ""
    }
  })
  // append selected option's value below selectbox ----------
  ;(root.querySelector("#incomeThreshold-options") as HTMLElement).addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
    validateSelectedOption()
  })

  ;(root.querySelector("#programFilesOptions") as HTMLElement).addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
    validateSelectedOption()
  })

  // add data to deal --------------------------------
  async function addLMIDataToDealRecord(programParticipation?: any, url?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","addLMIDataToDealRecord",[programParticipation,url],["programParticipation","url"]);
    var lmiFile1,
      lmiFile2,
      lmiFile3,
      lmiFile4,
      lmiFile5,
      lmiFile6,
      lmiFile7,
      lmiFile8,
      lmiFile9,
      lmiFile10,
      lmiFile11,
      lmiFile12
    if (url !== undefined) {
      if (url[0]) {
        lmiFile1 = url[0]
      } else {
        lmiFile1 = ""
      }
      if (url[1]) {
        lmiFile2 = url[1]
      } else {
        lmiFile2 = ""
      }
      if (url[2]) {
        lmiFile3 = url[2]
      } else {
        lmiFile3 = ""
      }
      if (url[3]) {
        lmiFile4 = url[3]
      } else {
        lmiFile4 = ""
      }
      if (url[4]) {
        lmiFile5 = url[4]
      } else {
        lmiFile5 = ""
      }
      if (url[5]) {
        lmiFile6 = url[5]
      } else {
        lmiFile6 = ""
      }
      if (url[6]) {
        lmiFile7 = url[6]
      } else {
        lmiFile7 = ""
      }
      if (url[7]) {
        lmiFile8 = url[7]
      } else {
        lmiFile8 = ""
      }
      if (url[8]) {
        lmiFile9 = url[8]
      } else {
        lmiFile9 = ""
      }
      if (url[9]) {
        lmiFile10 = url[9]
      } else {
        lmiFile10 = ""
      }
      if (url[10]) {
        lmiFile11 = url[10]
      } else {
        lmiFile11 = ""
      }
      if (url[11]) {
        lmiFile12 = url[11]
      } else {
        lmiFile12 = ""
      }
    } else {
      lmiFile1 = ""
      lmiFile2 = ""
      lmiFile3 = ""
      lmiFile4 = ""
      lmiFile5 = ""
      lmiFile6 = ""
      lmiFile7 = ""
      lmiFile8 = ""
      lmiFile9 = ""
      lmiFile10 = ""
      lmiFile11 = ""
      lmiFile12 = ""
    }
    var lmioptionvalue
    var incomeThreeshold = root.querySelector("#income-threshold-radio") as HTMLInputElement
    var programParticipationRadio = root.querySelector("#program-participation-radio") as HTMLInputElement
    var requestIncome = root.querySelector("#request-icome-radio") as HTMLInputElement
    var attestation = root.querySelector("#attestation-radio") as HTMLInputElement
    var attestationLMICheckboxContent: any = root.querySelector("#LMICheckboxContent") as HTMLInputElement
    var attestationelctsign = (root.querySelector("#elctsign") as HTMLInputElement).value
    var cencusTrackradio = root.querySelector("#cencus-track-radio") as HTMLInputElement
    var lmiofferId = storage.rawGet("offerIdYesLMI")
    if (incomeThreeshold.checked) {
      lmioptionvalue = "Threshold Opt-Out"
      lmiofferId = storage.rawGet("offerIdNoLMI")
    }
    if (programParticipationRadio.checked) {
      lmioptionvalue = "Program"
      if (selectedProgramSelection === "") {
        selectedProgramSelection === ""
      }
    }
    if (requestIncome.checked) {
      lmioptionvalue = "Income Verification"
    }
    if (attestation.checked) {
      lmioptionvalue = "Attestation"
    }
    if (cencusTrackradio.checked) {
      lmioptionvalue = "Census Tract Map Upload"
    }
    if (programParticipation === "") {
      programParticipation = ""
    }
    if (attestationLMICheckboxContent.checked) {
      attestationLMICheckboxContent = "Yes"
    } else {
      attestationLMICheckboxContent = "No"
    }
    var dealId = storage.rawGet("dealId")
    var catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          lmi_option: lmioptionvalue,
          lmi_attest_confirmation: attestationLMICheckboxContent,
          lmi_signature: attestationelctsign,
          lmi_program_doc_url_1: lmiFile1,
          lmi_program_doc_url_2: lmiFile2,
          lmi_program_doc_url_3: lmiFile3,
          lmi_program_doc_url_4: lmiFile4,
          lmi_program_doc_url_5: lmiFile5,
          lmi_program_doc_url_6: lmiFile6,
          lmi_program_doc_url_7: lmiFile7,
          lmi_program_doc_url_8: lmiFile8,
          lmi_program_doc_url_9: lmiFile9,
          lmi_program_doc_url_10: lmiFile10,
          lmi_program_doc_url_11: lmiFile11,
          lmi_program_doc_url_12: lmiFile12,
          lmi_program_selection: selectedProgramSelection,
          lmi_program_doc_selection: selectedOptText,
          lmi_my_usage: "yes",
          product_offer_id: lmiofferId,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      if (response.ok) {
        checkconcentvariation(lmioptionvalue)
      }
      catchdata = data
      void catchdata
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
      if (response.status === 500 || response.status === 404) {
        LMIcloseLoader()
      }
    } catch (error) {
      LMIcloseLoader()
      console.error("Error:", error)
    }
  }
  // add data to deal --------------------------------

  // Save my place button --------------------------------
  async function SaveButton(programParticipation?: any, url?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","SaveButton",[programParticipation,url],["programParticipation","url"]);
    void url
    var lmioptionvalue
    var incomeThreeshold = root.querySelector("#income-threshold-radio") as HTMLInputElement
    var programParticipationRadio = root.querySelector("#program-participation-radio") as HTMLInputElement
    var requestIncome = root.querySelector("#request-icome-radio") as HTMLInputElement
    var attestation = root.querySelector("#attestation-radio") as HTMLInputElement
    var attestationLMICheckboxContent: any = root.querySelector("#LMICheckboxContent") as HTMLInputElement
    var attestationelctsign = (root.querySelector("#elctsign") as HTMLInputElement).value
    if (incomeThreeshold.checked) {
      lmioptionvalue = "Threshold Opt-Out"
    }
    if (programParticipationRadio.checked) {
      lmioptionvalue = "Program"
    }
    if (requestIncome.checked) {
      lmioptionvalue = "Income Verification"
    }
    if (attestation.checked) {
      lmioptionvalue = "Attestation"
    }
    if (programParticipation === "") {
      programParticipation = ""
    }
    if (attestationLMICheckboxContent.checked) {
      attestationLMICheckboxContent = "Yes"
    } else {
      attestationLMICheckboxContent = "No"
    }
    var dealId = storage.rawGet("dealId")
    var catchdata: any = ""
    void catchdata
    try {
      const data = {
        properties: {
          deal_id: dealId,
          lmi_option: lmioptionvalue,
          lmi_attest_confirmation: attestationLMICheckboxContent,
          lmi_signature: attestationelctsign,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      if (response.ok) {
        // ok
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
      catchdata = data
    } catch (error) {
      console.error("Error:", error)
    }
  }

  ;(root.querySelector("#save-remind") as HTMLElement).addEventListener("click", () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
    var incomeThreesholdd = root.querySelector("#income-threshold-radio") as HTMLInputElement
    var requestIncomee = root.querySelector("#request-icome-radio") as HTMLInputElement
    var attestationRadio = root.querySelector("#attestation-radio") as HTMLInputElement
    if (incomeThreesholdd.checked || requestIncomee.checked || attestationRadio.checked) {
      SaveButton(selectedValue)
    } else {
      ;(async () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
        try {
          const url = await uploadFileToServer()
          SaveButton(selectedValue, url)
        } catch (error) {
        }
      })()
    }
  })
  // Save my place button  --------------------------------

  // append selected option's value below selectbox ----------
  optns = root.querySelector("#incomeThreshold-options") as HTMLSelectElement
  var optns2 = root.querySelector("#programFilesOptions") as HTMLSelectElement
  var selectedValue: any = ""
  var selectedOptText: any = ""
  optns.addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
    selectedValue = optns.options[optns.selectedIndex]
    selectedValue = selectedValue.innerText
  })

  optns2.addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
    selectedOptText = optns2.value
  })
  // append selected option's value below selectbox ----------

  // update Deal Stage -----------------------------------------------------------
  async function updateDealStageLMI(value?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","updateDealStageLMI",[value],["value"]);
    var dealId = storage.rawGet("dealId")
    await delay(2000)
    var catchdata: any = ""
    void catchdata
    try {
      const data = {
        properties: {
          deal_id: dealId,
          dealstage: value,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })

      if (response.ok) {
      }
      catchdata = data
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  void updateDealStageLMI
  //- update deaLstage -----------------------------------------------------------

  // checkConsentElementVariation ------------------------------------------------
  async function checkconcentvariation(lmioptionvalue?: any) {
__ea_trace("modules/savings/savings-intro-il.ts","checkconcentvariation",[lmioptionvalue],["lmioptionvalue"]);
    void lmioptionvalue
    var UsageDisplayElementList = JSON.parse(storage.rawGet("usageDisplayelementList") as any)
    var consentDisplayelementList = JSON.parse(storage.rawGet("consentDisplayelementList") as any)
    if (UsageDisplayElementList.length > 1) {
      // await updateDealStageLMI('127892569');
      LMIcloseLoader()
      window.location.href = "/il-usage" // redirect to normal hansen myusage page
    } else if (consentDisplayelementList.length > 0) {
      // await updateDealStageLMI('127892568');
      LMIcloseLoader()
      window.location.href = "/il-my-consent"
    }
  }
  // checkConsentElementVariation ------------------------------------------------

  ;(root.querySelector("#get-utility-info") as HTMLElement).addEventListener("click", () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
    LMIopenLoader()
    var isvalidated = RequireNotRequire()
    if (isvalidated) {
      var incomeThreesholdd = root.querySelector("#income-threshold-radio") as HTMLInputElement
      var attestationRadio = root.querySelector("#attestation-radio") as HTMLInputElement
      if (incomeThreesholdd.checked || attestationRadio.checked) {
        addLMIDataToDealRecord(selectedValue)
      } else {
        ;(async () => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[],[]);
          try {
            const url = await uploadFileToServer()
            if (Array.isArray(url) && url.length === 0) {
              ;(root.querySelector("#file-error-message") as HTMLElement).innerHTML = "Please upload an file."
              LMIcloseLoader()
            } else {
              ;(root.querySelector("#file-error-message") as HTMLElement).innerHTML = ""
              addLMIDataToDealRecord(selectedValue, url)
            }
          } catch (error) {
            addLMIDataToDealRecord(selectedValue)
          }
        })()
      }
    } else {
      LMIcloseLoader()
    }
  })

  function validateSelectedOption() {
__ea_trace("modules/savings/savings-intro-il.ts","validateSelectedOption",[],[]);
    var selectedOption = (root.querySelector("#incomeThreshold-options") as HTMLSelectElement).value
    var selectedOption1 = (root.querySelector("#programFilesOptions") as HTMLSelectElement).value
    var optionError = root.querySelector("#optionError") as HTMLElement
    var optionError1 = root.querySelector("#optionError1") as HTMLElement

    if (selectedOption === "Select an option") {
      optionError.innerHTML = "Please select an option."
      return "error"
    } else {
      optionError.innerHTML = ""
      if (selectedOption1 === "Select an option") {
        optionError1.innerHTML = "Please select an option."
        return "error"
      } else {
        optionError1.innerHTML = ""
        return null
      }
    }
  }
  function validateCheckSignature() {
__ea_trace("modules/savings/savings-intro-il.ts","validateCheckSignature",[],[]);
    var LMICheckboxContent = root.querySelector("#LMICheckboxContent") as HTMLInputElement
    var elctsign = (root.querySelector("#elctsign") as HTMLInputElement).value
    var attestation_error = root.querySelector("#attestation_error_message") as HTMLElement
    if (!LMICheckboxContent.checked || elctsign === "" || elctsign === " " || elctsign == null) {
      attestation_error.innerHTML = "Please complete required fields"
      return "error"
    } else {
      attestation_error.innerHTML = ""
      return null
    }
  }
  function toggleContent(radio: any) {
__ea_trace("modules/savings/savings-intro-il.ts","toggleContent",[radio],["radio"]);
    var itemsContainer = document.querySelector(".ipiaap-items") as HTMLElement
    var itemsContainer1 = document.querySelector(".ipiaap-items-1") as HTMLElement
    var itemsContainer2 = document.querySelector(".ipiaap-items-2") as HTMLElement
    var itemsContainer3 = document.querySelector(".ipiaap-items-3") as HTMLElement
    itemsContainer.style.display = radio.value === "green" ? "block" : "none"
    itemsContainer1.style.display = radio.value === "orange" ? "block" : "none"
    itemsContainer2.style.display = radio.value === "cencus" ? "block" : "none"
    itemsContainer3.style.display = radio.value === "blue" ? "block" : "none"
  }

  var utilityIdSession: any
  var LmiAvailability: any
  var LmiCensusAvailability: any
  var DisplayLmiElementList: any[] = []
  void DisplayLmiElementList
  var requireLmiElementList: any[] = []
  void requireLmiElementList
  var LMICensusTractLevels: any

  var sampleSessiontype: any
  void sampleSessiontype
  var sampleOriginType: any
  void sampleOriginType

  if (storage.rawGet("attcode") != null) {
    sampleOriginType = "Invite"
    sampleSessiontype = "Consumer Completing"
  } else {
    sampleOriginType = "Direct"
    sampleSessiontype = "Consumer Only"
  }
  // ------------- Get saved data -------------------------------
  var offerId: any = ""
  var lmiCensusTractLevel: any = ""
  void lmiCensusTractLevel

  async function getAvailability() {
__ea_trace("modules/savings/savings-intro-il.ts","getAvailability",[],[]);
    LMIopenLoader()
    var exampleUtilityId = storage.rawGet("utility_id")
    const hubDBEndpoint = hubdbRowsUrl("utilityAvailability", {
      utility_id__eq: exampleUtilityId as string,
    })
    const response = await fetch(hubDBEndpoint, { method: "GET" })
    const data = await response.json()
    const rows = data.objects
    var IsUtilityIdMatched = false
    void IsUtilityIdMatched
    if (rows.length >= 1) {
      storage.rawSet("Session Config ID", rows[0].id)
      rows.forEach((element: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          storage.rawSet("stateForLMIConfig", element.values["13"].name)
          if (element.values["24"] !== undefined) {
            storage.rawSet("credentialProvider", element.values["24"].name)
          }
          IsUtilityIdMatched = true
          utilityIdSession = element.values["1"]
          void utilityIdSession
          if (element.values["68"]) {
            LMICensusTractLevels = element.values["68"].name
          }
          if (element.values["30"] === "1") {
            LmiAvailability = "Yes"
          } else if (element.values["30"] === "0") {
            LmiAvailability = "No"
          } else {
            LmiAvailability = ""
          }
          if (element.values["31"] === "1") {
            LmiCensusAvailability = "Yes"
          } else if (element.values["31"] === "0") {
            LmiCensusAvailability = "No"
          } else {
            LmiCensusAvailability = ""
          }
          lmiFlow()
        } else {
          LMIcloseLoader()
        }
      })
    } else {
      LMIcloseLoader()
    }
  }
  async function getOfferIDFromFarmProductsNoLMI() {
__ea_trace("modules/savings/savings-intro-il.ts","getOfferIDFromFarmProductsNoLMI",[],[]);
    var farmId = storage.rawGet("FarmID")
    var OfferTypeVal = "Open"
    try {
      const hubDBEndpoint = hubdbRowsUrl("farms", {
        farm_id: farmId as string,
        offer_type: OfferTypeVal,
      })
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      var rows = data.objects
      if (rows.length >= 1) {
        offerId = rows[0].values[3]
        storage.rawSet("offerIdNoLMI", offerId)
      }
    } catch (error) {
      console.error("Error in Farm Product hubdb fetch block:", error)
    }
  }
  async function getOfferIDFromFarmProductsYesLMI() {
__ea_trace("modules/savings/savings-intro-il.ts","getOfferIDFromFarmProductsYesLMI",[],[]);
    var farmId = storage.rawGet("FarmID")
    var OfferTypeVal = "LMI"
    try {
      const hubDBEndpoint = hubdbRowsUrl("farms", {
        farm_id: farmId as string,
        offer_type: OfferTypeVal,
      })
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      var rows = data.objects
      if (rows.length >= 1) {
        offerId = rows[0].values[3]
        storage.rawSet("offerIdYesLMI", offerId)
      }
    } catch (error) {
      console.error("Error in Farm Products hubdb fetch block:", error)
    }
  }
  async function lmiFlow() {
__ea_trace("modules/savings/savings-intro-il.ts","lmiFlow",[],[]);
    if (LmiAvailability === "No") {
      await getOfferIDFromFarmProductsNoLMI()
      window.location.href = "/il-usage" // redirect to logInIl page
      LMIcloseLoader()
    } else if (LmiAvailability === "Yes" && LmiCensusAvailability === "No") {
      await getOfferIDFromFarmProductsYesLMI()
      await getOfferIDFromFarmProductsNoLMI()
      exampleUtilityId = storage.rawGet("utility_id")
      var stateForLMIConfig = storage.rawGet("stateForLMIConfig")
      const hubDBEndpointLMIC = hubdbRowsUrl("lmiConfig", {
        orderBy: "lmi_sequence",
        utility_id: exampleUtilityId as string,
        state: stateForLMIConfig as string,
      })
      const responseLMIC = await fetch(hubDBEndpointLMIC, { method: "GET" })
      const dataLMIC = await responseLMIC.json()
      const rowsLMIC = dataLMIC.objects
      ;(document.querySelector("#Income_Exceed_Threshold") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Program_Participation") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Request_Income_Check") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Attestation") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Attestation .LMICheckCont") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Attestation .LMISignature") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Cencus_tract_map_upload") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Cencus_tract_map_upload .ipiaap-items-2") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Cencus_tract_map_upload #cencus-track-radio") as HTMLElement).style.display = "none"
      ;(document.querySelector("#Cencus_tract_map_upload .LMISignature") as HTMLElement).style.display = "none"
      if (rowsLMIC.length >= 1) {
        rowsLMIC.forEach((element: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[element],["element"]);
          renderLmiOption(element)
        })
      } else {
        // (empty)
      }
      var lmifieldswrapperul = document.querySelector(".lmifieldswrapper") as HTMLElement
      var lmifieldswrapperlistItems = Array.from(lmifieldswrapperul.querySelectorAll(".list"))
      lmifieldswrapperlistItems.sort((a, b) => Number(a.getAttribute("order")) - Number(b.getAttribute("order")))
      lmifieldswrapperul.innerHTML = ""
      lmifieldswrapperlistItems.forEach((item) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[item],["item"]);
        lmifieldswrapperul.appendChild(item)
      })
      // show hide widgets
      LMIcloseLoader()
    } else if (LmiAvailability === "Yes" && LmiCensusAvailability === "Yes") {
      await getOfferIDFromFarmProductsYesLMI()
      await getOfferIDFromFarmProductsNoLMI()
      // External Hansen census-validation endpoint — left as an absolute URL.
      const hensonApiUrl = "https://hansen.danmarcrm.com/lmiHansen.php"
      const requestBody = {
        line1: (document.querySelector("#page_1_my_info_widget #address1") as HTMLInputElement).value.trim(),
        city: (document.querySelector("#page_1_my_info_widget #city") as HTMLInputElement).value.trim(),
        state: (document.querySelector("#page_1_my_info_widget #state") as HTMLInputElement).value,
        zip: (document.querySelector("#page_1_my_info_widget #code") as HTMLInputElement).value.trim(),
      }
      var catchdata: any = ""
      void catchdata
      try {
        const response = await fetch(hensonApiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        })
        catchdata = requestBody
        const responseData = await response.json()
        responseFromAPI = JSON.stringify(responseData)
        if (responseData.result === "valid") {
          lmiCensusTractLevel = LMICensusTractLevels
          LMIcloseLoader()
        } else if (responseData.result === "notvalid") {
          lmiCensusTractLevel = LMICensusTractLevels
          exampleUtilityId = storage.rawGet("utility_id")
          var stateForLMIConfig = storage.rawGet("stateForLMIConfig")
          const hubDBEndpointLMIC = hubdbRowsUrl("lmiConfig", {
            orderBy: "lmi_sequence",
            utility_id: exampleUtilityId as string,
            state: stateForLMIConfig as string,
          })
          const responseLMIC = await fetch(hubDBEndpointLMIC, { method: "GET" })
          const dataLMIC = await responseLMIC.json()
          const rowsLMIC = dataLMIC.objects
          ;(document.querySelector("#Income_Exceed_Threshold") as HTMLElement).style.display = "none"
          ;(document.querySelector("#Program_Participation") as HTMLElement).style.display = "none"
          ;(document.querySelector("#Request_Income_Check") as HTMLElement).style.display = "none"
          ;(document.querySelector("#Attestation") as HTMLElement).style.display = "none"
          ;(document.querySelector("#Attestation .LMICheckCont") as HTMLElement).style.display = "none"
          ;(document.querySelector("#Attestation .LMISignature") as HTMLElement).style.display = "none"
          ;(document.querySelector("#Cencus_tract_map_upload") as HTMLElement).style.display = "none"
          ;(document.querySelector("#Cencus_tract_map_upload .ipiaap-items-2") as HTMLElement).style.display = "none"
          ;(document.querySelector("#Cencus_tract_map_upload #cencus-track-radio") as HTMLElement).style.display =
            "none"
          ;(document.querySelector("#Cencus_tract_map_upload .LMISignature") as HTMLElement).style.display = "none"
          if (rowsLMIC.length >= 1) {
            rowsLMIC.forEach((element: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[element],["element"]);
              renderLmiOption(element)
            })
          } else {
            // (empty)
          }
          var lmifieldswrapperul = document.querySelector(".lmifieldswrapper") as HTMLElement
          var lmifieldswrapperlistItems = Array.from(lmifieldswrapperul.querySelectorAll(".list"))
          lmifieldswrapperlistItems.sort((a, b) => Number(a.getAttribute("order")) - Number(b.getAttribute("order")))
          lmifieldswrapperul.innerHTML = ""
          lmifieldswrapperlistItems.forEach((item) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[item],["item"]);
            lmifieldswrapperul.appendChild(item)
          })
          // show hide widgets
          LMIcloseLoader()
        } else {
          LMIcloseLoader()
          alert("Unexpected Error")
          location.reload()
        }
      } catch (error) {
        console.error("Error calling API:", error)
      }
    }
  }

  // Renders a single LMI-config row into its matching option block. Extracted
  // verbatim from the two identical inline forEach bodies in lmiFlow (Census "No"
  // and Census "Yes"→notvalid paths) — same code, deduplicated.
  function renderLmiOption(element: any) {
__ea_trace("modules/savings/savings-intro-il.ts","renderLmiOption",[element],["element"]);
    var lmiOptAvl = element.values["5"].name
    var lmiOptType = element.values["6"].name
    var lmiSeq = element.values["4"]
    var lmiOptText = element.values["7"]
    var lmiInLineText = element.values["9"]
    var lmiCheckbox = element.values["12"].name
    var lmiSignature = element.values["16"].name
    var lmiCheckContent = element.values["13"]
    var fileUploadControl = element.values["14"]
    var lmiOptionLinkText = element.values["17"]
    var lmiOptionLink
    if (lmiOptionLinkText) {
      lmiOptionLink = element.values["8"]
    }
    if (lmiOptAvl === "Yes" && lmiOptType === "Threshold Opt-Out") {
      ;(document.querySelector(".lmifieldswrapper .iethItem") as HTMLElement).setAttribute("order", lmiSeq)
      ;(document.querySelector("#Income_Exceed_Threshold") as HTMLElement).style.display = "block"
      ;(document.querySelector("#Income_Exceed_Threshold .lmiOptText") as HTMLElement).innerHTML = lmiOptText
      ;(document.querySelector("#Income_Exceed_Threshold .lmiInLineTxt") as HTMLElement).innerHTML = lmiInLineText
      if (lmiOptionLink) {
        ;(document.querySelector("#Income_Exceed_Threshold .lmiLinkTxt") as HTMLElement).innerHTML =
          `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
      }
    } else if (lmiOptAvl === "Yes" && lmiOptType === "Program") {
      ;(document.querySelector(".lmifieldswrapper .ppItem") as HTMLElement).setAttribute("order", lmiSeq)
      ;(document.querySelector("#Program_Participation") as HTMLElement).style.display = "block"
      ;(document.querySelector("#Program_Participation .lmiOptText") as HTMLElement).innerHTML = lmiOptText
      ;(document.querySelector("#Program_Participation .lmiInLineTxt") as HTMLElement).innerHTML = lmiInLineText
      if (lmiOptionLink) {
        ;(document.querySelector("#Program_Participation .lmiLinkTxt") as HTMLElement).innerHTML =
          `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
      }
      var lmiProgOpts = element.values["10"]
      var lmiDocsOpts = element.values["11"]
      var lmiProgOptsarray = lmiProgOpts.split(",")
      var prgselectbx = document.querySelector("#Program_Participation #incomeThreshold-options") as HTMLSelectElement
      lmiProgOptsarray.forEach((item: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[item],["item"]);
        var option = document.createElement("option")
        option.text = item
        prgselectbx.add(option)
      })

      var lmiDocsOptsitems = lmiDocsOpts.split("|")
      var lmiDocsOptsresult: any[] = []
      lmiDocsOptsitems.forEach((item: any) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[item],["item"]);
        var parts = item.split(":")
        var key = parts[0]
        var value = parts[1].split(",")
        var obj: any = {}
        obj[key] = value
        lmiDocsOptsresult.push(obj)
        var prgselectbxoptionsAll = prgselectbx.querySelectorAll("option")
        prgselectbxoptionsAll.forEach((option) => {
__ea_trace("modules/savings/savings-intro-il.ts","(anon)",[option],["option"]);
          if (option.text === key) {
            option.setAttribute("value", value)
          }
        })
      })
    } else if (lmiOptAvl === "Yes" && lmiOptType === "Income Verification") {
      ;(document.querySelector(".lmifieldswrapper .rICItem") as HTMLElement).setAttribute("order", lmiSeq)
      ;(document.querySelector("#Request_Income_Check") as HTMLElement).style.display = "block"
      ;(document.querySelector("#Request_Income_Check .lmiOptText") as HTMLElement).innerHTML = lmiOptText
      ;(document.querySelector("#Request_Income_Check .lmiInLineTxt") as HTMLElement).innerHTML = lmiInLineText
      if (lmiOptionLink) {
        ;(document.querySelector("#Request_Income_Check .lmiLinkTxt") as HTMLElement).innerHTML =
          `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
      }
    } else if (lmiOptAvl === "Yes" && lmiOptType === "Attestation") {
      ;(document.querySelector(".lmifieldswrapper .attsItem") as HTMLElement).setAttribute("order", lmiSeq)
      ;(document.querySelector("#Attestation") as HTMLElement).style.display = "block"
      ;(document.querySelector("#Attestation .lmiOptText") as HTMLElement).innerHTML = lmiOptText
      ;(document.querySelector("#Attestation .lmiInLineTxt") as HTMLElement).innerHTML = lmiInLineText
      if (lmiCheckbox === "Yes") {
        ;(document.querySelector("#Attestation .LMICheckCont") as HTMLElement).style.display = "block"
        ;(document.querySelector("#Attestation .LMICheckCont label span") as HTMLElement).innerHTML = lmiCheckContent
      }
      if (lmiSignature === "Yes") {
        ;(document.querySelector("#Attestation .LMISignature") as HTMLElement).style.display = "block"
      }
      if (lmiOptionLink) {
        ;(document.querySelector("#Attestation .lmiLinkTxt") as HTMLElement).innerHTML =
          `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
      }
    } else if (lmiOptAvl === "Yes" && lmiOptType === "Census Tract Map Upload") {
      ;(document.querySelector(".lmifieldswrapper .ctmuItem") as HTMLElement).setAttribute("order", lmiSeq)
      ;(document.querySelector("#Cencus_tract_map_upload") as HTMLElement).style.display = "block"
      ;(document.querySelector("#Cencus_tract_map_upload .lmiOptText") as HTMLElement).innerHTML = lmiOptText
      ;(document.querySelector("#Cencus_tract_map_upload .lmiInLineTxt") as HTMLElement).innerHTML = lmiInLineText
      if (lmiSignature === "Yes") {
        ;(document.querySelector("#Cencus_tract_map_upload .LMISignature") as HTMLElement).style.display = "block"
      }
      if (lmiOptionLink) {
        ;(document.querySelector("#Cencus_tract_map_upload .lmiLinkTxt") as HTMLElement).innerHTML =
          `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
      }
      if (fileUploadControl.name === "Yes") {
        ;(document.querySelector("#Cencus_tract_map_upload #cencus-track-radio") as HTMLElement).style.display = "block"
      }
    }
  }
  /* -- validation --------------------------------- */

  // ─── wire the (formerly inline) handlers (rule G) ────────────────────────────
  const bind = (sel: string, type: string, fn: (e: any) => void) => {
__ea_trace("modules/savings/savings-intro-il.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  // radios → toggleContent(this)
  ;[
    "#income-threshold-radio",
    "#program-participation-radio",
    "#cencus-track-radio",
    "#request-icome-radio",
    "#attestation-radio",
  ].forEach((sel) => bind(sel, "click", (e) => toggleContent(e.currentTarget)))

  // program (non-census/income) upload group
  bind("#dropArea", "drop", (e) => dropHandler(e, false))
  bind("#dropArea", "dragover", (e) => dragOverHandler(e, false))
  bind("#dropArea", "click", () => triggerFilePicker())
  bind("#mobileCamera img", "click", (e) => triggerFileInput(e, false, false))
  bind("#mobileCamera a", "click", (e) => triggerFileInput(e, false, false))
  bind("#Program_Participation .uploadRemoveButtons button:not([id])", "click", () => triggerFilePicker())
  bind("#removeimagebutton", "click", () => removeImageOpenPopup(false))
  bind(".RemoveFilePopup .removefilePopButtons button:not([id])", "click", () => removeCurrentImage(false))
  bind("#keepIt", "click", () => removeImageClosePopup(false))

  // census upload group
  bind("#censusDropArea", "drop", (e) => dropHandler(e, true))
  bind("#censusDropArea", "dragover", (e) => dragOverHandler(e, true))
  bind("#censusDropArea", "click", () => triggerCensusFilePicker())
  bind("#censusMobileCamera img", "click", (e) => triggerFileInput(e, true, false))
  bind("#censusMobileCamera a", "click", (e) => triggerFileInput(e, true, false))
  bind("#Cencus_tract_map_upload .uploadRemoveButtons button:not([id])", "click", () => triggerCensusFilePicker())
  bind("#censusRemoveimagebutton", "click", () => removeImageOpenPopup(true))
  bind(".census-RemoveFilePopup .removefilePopButtons button:not([id])", "click", () => removeCurrentImage(true))
  bind(".census-RemoveFilePopup #keepItt", "click", () => removeImageClosePopup(true))

  // income upload group  (note: the original income drop/dragover pass `true`, i.e.
  // they are handled as census — preserved faithfully)
  bind("#incomeDropArea", "drop", (e) => dropHandler(e, true))
  bind("#incomeDropArea", "dragover", (e) => dragOverHandler(e, true))
  bind("#incomeDropArea", "click", () => triggerincomeFilePicker())
  bind("#incomeMobileCamera img", "click", (e) => triggerFileInput(e, false, true))
  bind("#incomeMobileCamera a", "click", (e) => triggerFileInput(e, false, true))
  bind("#Request_Income_Check .uploadRemoveButtons button:not([id])", "click", () => triggerincomeFilePicker())
  bind("#incomeRemoveimagebutton", "click", () => removeImageOpenPopup(true))
  bind(".income-RemoveFilePopup .removefilePopButtons button:not([id])", "click", () => removeCurrentImage(true))
  bind(".income-RemoveFilePopup #keepItt", "click", () => removeImageClosePopup(true))

  getAvailability()
}
